import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  let userProfile: any;

  authService.profile$.subscribe((profile) => {
    userProfile = profile;
  });
  let userRoles = authService.getUserRoles();

  if (userRoles && userRoles.includes('Admin')) return true;
  else {
    router.navigate(['/dashboard']);

    return false;
  }
};
